module.exports = __webpack_public_path__ + "img/AggregateFunction.e0aaf358.svg";